import { render, staticRenderFns } from "./strageList.vue?vue&type=template&id=ffab09b8&scoped=true&"
import script from "./strageList.vue?vue&type=script&lang=js&"
export * from "./strageList.vue?vue&type=script&lang=js&"
import style0 from "./strageList.vue?vue&type=style&index=0&id=ffab09b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffab09b8",
  null
  
)

export default component.exports